<template>
    <div>
        <modal
            @before-close="beforeClose"
            @before-open="beforeOpen"
            name="site-modal"
            :min-width="1072"
            :max-width="1072"
            height="auto"
            click-to-close
            scrollable
            adaptive
            draggable=".site-title-bar">
                <site :data="site" is-modal></site>
        </modal>
    </div>
</template>

<script>
    export default {
        data() {
            return { 
                site: "",
            }
        },

        methods: {
            beforeClose() {
                this.$emit('closed');
            },

            beforeOpen(event) {
                this.site = event.params.site;
            }
        }
    }
</script>